import React, { createContext, useContext, useState, ReactNode } from 'react';

interface UnsavedChangesContextType {
	hasUnsavedChanges: boolean;
	setHasUnsavedChanges: (value: boolean) => void;
	pendingNavigation: string | null;
	setPendingNavigation: (path: string | null) => void;
	onSaveCallback: (() => Promise<void>) | null;
	setOnSaveCallback: (callback: (() => Promise<void>) | null) => void;
}

const UnsavedChangesContext = createContext<
	UnsavedChangesContextType | undefined
>(undefined);

export const UnsavedChangesProvider = ({
	children,
}: {
	children: ReactNode;
}) => {
	const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
	const [pendingNavigation, setPendingNavigation] = useState<string | null>(
		null
	);
	const [onSaveCallback, setOnSaveCallback] = useState<
		(() => Promise<void>) | null
	>(null);

	return (
		<UnsavedChangesContext.Provider
			value={{
				hasUnsavedChanges,
				setHasUnsavedChanges,
				pendingNavigation,
				setPendingNavigation,
				onSaveCallback,
				setOnSaveCallback,
			}}
		>
			{children}
		</UnsavedChangesContext.Provider>
	);
};

export const useUnsavedChangesContext = () => {
	const context = useContext(UnsavedChangesContext);
	if (!context) {
		throw new Error(
			'useUnsavedChangesContext must be used within UnsavedChangesProvider'
		);
	}
	return context;
};
